import { gql } from '@/apollo';

export const GET_PUBLIC_BRANDING = gql`
  query GetPublicBranding {
    publicBranding {
      applicationName
      companyName
    }
  }
`;

export const GET_APPLICATION_SETTINGS = gql`
  query GetApplicationSettings {
    applicationSettings {
      applicationName
      companyName
      supportEmail
      defaultTimezone
      notesEnabled
      bulletinsEnabled
      sessionSettings {
        sessionMaxDurationHours
        sessionCleanupIntervalHours
        maxConcurrentSessions
        suspiciousActivityThreshold
        sessionInactivityDays
        enableSessionAnalytics
        enableSessionFingerprinting
        enableGeoTracking
      }
      geolocationSettings {
        enabled
        mode
        countries
        availableCountries {
          code
          name
        }
      }
    }
  }
`;

export const GET_SESSION_SETTINGS = gql`
  query GetSessionSettings {
    sessionSettings {
      sessionMaxDurationHours
      sessionCleanupIntervalHours
      maxConcurrentSessions
      suspiciousActivityThreshold
      sessionInactivityDays
      enableSessionAnalytics
      enableSessionFingerprinting
      enableGeoTracking
    }
  }
`;

export const UPDATE_APPLICATION_SETTINGS = gql`
  mutation UpdateApplicationSettings($input: UpdateApplicationSettingsInput!) {
    updateApplicationSettings(input: $input) {
      applicationName
      companyName
      supportEmail
      defaultTimezone
      notesEnabled
      bulletinsEnabled
      sessionSettings {
        sessionMaxDurationHours
        sessionCleanupIntervalHours
        maxConcurrentSessions
        suspiciousActivityThreshold
        sessionInactivityDays
        enableSessionAnalytics
        enableSessionFingerprinting
        enableGeoTracking
      }
    }
  }
`;

export const UPDATE_SESSION_SETTINGS = gql`
  mutation UpdateSessionSettings($input: UpdateSessionSettingsInput!) {
    updateSessionSettings(input: $input) {
      sessionMaxDurationHours
      sessionCleanupIntervalHours
      maxConcurrentSessions
      suspiciousActivityThreshold
      sessionInactivityDays
      enableSessionAnalytics
      enableSessionFingerprinting
      enableGeoTracking
    }
  }
`;

export const RESET_SESSION_SETTINGS = gql`
  mutation ResetSessionSettings {
    resetSessionSettings {
      sessionMaxDurationHours
      sessionCleanupIntervalHours
      maxConcurrentSessions
      suspiciousActivityThreshold
      sessionInactivityDays
      enableSessionAnalytics
      enableSessionFingerprinting
      enableGeoTracking
    }
  }
`;

export const RESET_APPLICATION_SETTINGS = gql`
  mutation ResetApplicationSettings {
    resetApplicationSettings {
      applicationName
      companyName
      supportEmail
      defaultTimezone
      notesEnabled
      bulletinsEnabled
    }
  }
`;

export const UPDATE_GEOLOCATION_SETTINGS = gql`
  mutation UpdateGeolocationSettings($input: UpdateGeolocationSettingsInput!) {
    updateGeolocationSettings(input: $input) {
      enabled
      mode
      countries
      availableCountries {
        code
        name
      }
    }
  }
`;
